import "./styles.scss";

import { useState } from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import DetailsCard from "components/DetailsCard";
import {
  ChooseProject,
  SummaryProject,
  ConfirmationProject,
} from "./components";
import AnimatedGradient from "components/AnimatedGradient";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";
import api from "libs/api";
import gradient_props from "libs/gradient_props";

const mainClass = "new-project-content";

const NewProjectContent = () => {
  const { t } = useTranslation();
  const { min, max } = useResponsive();
  const { theme } = useApp();

  const [formSent, setFormSent] = useState(false);

  const onSubmit = (values, setSubmitting) => {
    api
      .post("/client/websites/new-project-form", values)
      .then(() => {
        setFormSent(true);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  const { time, seed, colors } = gradient_props.green;

  return !formSent ? (
    <DetailsCard resetOnMobile>
      <div className={mainClass}>
        <div className={`${mainClass}__column`}>
          <div className={`${mainClass}__info`}>
            <div>
              <h3>{t("We support your business on multiple levels")}</h3>
              <p>
                {t(
                  "Choose the project you would like to carry out and describe it in detail. Our specialists will analyze your request and prepare an offer tailored to your needs.",
                )}
              </p>
            </div>
            <div className={`${mainClass}__info-background`}>
              {min.sm && (
                <AnimatedGradient
                  id="info-gradient"
                  time={time}
                  seed={seed}
                  colors={colors[theme]}
                />
              )}
            </div>
          </div>
        </div>
        <div className={`${mainClass}__column`}>
          <Formik
            initialValues={{
              options: [],
              message: "",
            }}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
              onSubmit(values, setSubmitting);
            }}
          >
            <Form autoComplete="off">
              <ChooseProject />
              <SummaryProject />
            </Form>
          </Formik>
        </div>
      </div>
      {max.sm && (
        <div className={`${mainClass}__scroll`}>
          <ScrollTopMobile />
        </div>
      )}
    </DetailsCard>
  ) : (
    <ConfirmationProject />
  );
};

export default NewProjectContent;
